export default __webpack_public_path__ + "static/media/games-puzzles.a484aa61.png";